import React, { useEffect, useState, useContext, useRef } from 'react';
import Modal from '../../../UI/Modal/Modal'
import cl from './Item.module.css'
import CheckIcon from "../../../../assets/Icon/Task"; 
import Plus from "../../../../assets/Icon/Plus"; 
import Eye from "../../../../assets/Icon/Eye"; 
import Select from "react-select"; 
import { selectStyle } from './selectStyle';
import { AppContext } from '../../../../providers/appProvider';
import { useAuth } from '../../../../providers/authProvider';
import DatePicker from "react-datepicker"; 
import moment from 'moment-timezone';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css'; 
import CalendarIcon from "../../../../assets/Icon/Calendar";  
import User from "../../../../assets/Icon/User";  
import { useMessage } from '../../../../hooks/useMessage';
import { useUser } from '../../../../hooks/useUser';
import { useTranslation } from 'react-i18next';

const ItemTaskModal = ({ taskService, defaultTask, modalType = 'add', author }) => {
    const {t} = useTranslation();
    const { messageService } = useMessage();
    const { userService } = useUser();

    const { appState, app } = useContext(AppContext);
    const auth = useAuth();  
   
    const taskResetData = {
        id:0,
        title: t('Task'),
        auth_id: parseInt(auth.session.id, 10),  
        user_id: '',
        priority: 2,  
        content: '', 
        deadline_at: null,
        created_at: new Date(new Date().getTime()),  
    }
 
    

    const [newTask, setNewTask] = useState(taskResetData)
    const [oldTask, setOldTask] = useState(taskResetData)
    const [creator, setCreator] = useState()
    const [performer, setPerformer] = useState()
    const [isFirstValidated, setIsFirstValidated] = useState(false)
    const [validates, setValidates] = useState({})
    const [isModalOpen, setIsModalOpen] = useState(false);

    const validateTask = (task) => {

        const messages = {};
     

        if (task.title.length < 1) {
            messages.title = { message: 'სავალდებულოა', isValid: false };
        }

        if (task.user_id < 1) {
            messages.user_id = { message: 'სავალდებულოა', isValid: false };
        }

       
        const isValid = Object.keys(messages).length === 0;
        setValidates(messages)
        return isValid;  
      };

    const reValidate = () => {

        const isValidate = validateTask(newTask)
    }

    useEffect(() => {
        if (isFirstValidated === true) {
            const isValidate = validateTask(newTask)    
        
        }
 

    }, [newTask, isFirstValidated]);

    

    const initEditTask = (task) => {

        return {
            id: task.id,
            title: task.title,
            auth_id: task.auth_id,  
            user_id: task.user_id,
            priority: task.priority,
            status:task.status,
            content: task.content,
            deadline_at: task.deadline_at ? new Date(task.deadline_at) : null, 
            created_at: task.created_at,  
        }

    }

    
    useEffect(() => { 
        if (modalType === 'update') {  
            const editedCar = initEditTask(defaultTask);
            setOldTask(editedCar);
            setNewTask(editedCar);
        }
    }, [defaultTask]);
 

    
    const saveHandle = () => {
        const isValidate = validateTask(newTask);
    
        if (isValidate === true) {
            const taskWithTimeZone = {
                ...newTask,
                deadline_at: newTask.deadline_at 
                    ? moment(newTask.deadline_at).tz('Europe/Tbilisi').format() 
                    : null,  
            };
    
            if (modalType === 'add') { 

                taskService.add(taskWithTimeZone).then(() => {

                    const mobileAuth = creator.mobile; 
                    const mobile = performer.mobile;
                    const text = creator.firstname + ' '+ creator.lastname +'-მ შექმნა ახალი დავალება ' + performer.firstname + ' '+ performer.lastname + '-ს სახელზე'  ;
                    
                    messageService.add(mobile, text);
                    messageService.add(mobileAuth, text);
     
                }).catch((error) => {
                    console.error("შეცდომა დავალების დამატებისას:", error);
                });

            }

            if (modalType === 'update') { 
 
                taskService.update(taskWithTimeZone).then(() => {

                        if(oldTask.status == 0 && newTask.status == 1) {

                            const mobileAuth = creator.mobile; 
                            const mobile = performer.mobile;
                            const text = performer.firstname + ' '+ performer.lastname + '-მ შეასრულა ' + creator.firstname + ' '+ creator.lastname+ '-ს დავალება: #'+ newTask.id+ ' '+ newTask.title   ;
                            
                            messageService.add(mobile, text);
                            messageService.add(mobileAuth, text);
 
                        }
     
                    
     
                }).catch((error) => {
                    console.error("შეცდომა დავალების ვლილებისას:", error);
                });

            }

             setIsModalOpen(false);
        } else {
            setIsFirstValidated(true);
        }
    };

    
    const openItem = () => {
        setValidates({})
        setIsModalOpen(true) 
        setIsFirstValidated(false)
        if (modalType === 'add') {  
            setNewTask(taskResetData)

        }



        if (modalType === 'add') { 
  
            userService.getUserById(parseInt(auth.session.id, 10)).then((user) => {
                setCreator(user); 
            }).catch((error) => {
                console.error("მომხმარებელი ვერ მოიძებნა:", error);
            });
    
        }

        if (modalType === 'update') { 
     
            userService.getUserById(oldTask.auth_id).then((user) => {
                setCreator(user); 
            }).catch((error) => {
                console.error("მომხმარებელი ვერ მოიძებნა:", error);
            });
 
            userService.getUserById(oldTask.user_id).then((user) => {
                setPerformer(user);
            }).catch((error) => {
                console.error("მომხმარებელი ვერ მოიძებნა:", error);
            });
     
        }


      

    }
 
    const stylesError = { 
        control: (provided, state) => ({
            ...provided,
            border: state.isFocused ? '1px solid rgb(225 29 72)' : '1px solid rgb(225 29 72)',
            boxShadow: state.isFocused ? 'none' : 'none',
            '&:hover': {
                border: state.isFocused ? '1px solid rgb(225 29 72)' : '1px solid rgb(225 29 72)',  
            },
            minHeight: "35px",
            width: '100%',
            cursor: 'pointer',
            borderRadius: '5px',
        }),

    };
 
    const salers = appState.salers.map((user) => ({ value: user.id, label: user.firstname + " " + user.lastname })); 
  
    const priorities = [
        { id: 1, name: t('High'), color: "#d80228" },
        { id: 2, name: t('Medium'), color: "#f1c40f" },
        { id: 3, name: t('Low'), color: "#1254e7" },
    ];

    const priority_options = priorities.map((status) => ({ value: status.id, label: status.name ,  color: status.color}));
 
    const dot = (color = 'transparent') => ({
        alignItems: 'center',
        color: 'var(--text-color)', 
        display: 'flex', 
        ':before': {
            backgroundColor: color,
            borderRadius: 10,
            content: '" "',
            display: 'block',
            marginRight: 4,
            minHeight: 10,
            minWidth: 10,
        },
    });
 
    const colourStyles = { 

        option: (styles, { data, isDisabled, isFocused, isSelected }) => {
            
            let backgroundColor;
            let color;
            let cursor = isDisabled ? 'not-allowed' : 'pointer';
        
            if (isDisabled) {
            backgroundColor = undefined;
            color = '#ccc';
            } else if (isSelected) {
            // backgroundColor = data.color;
            backgroundColor = '#f1f1f1';
            color = undefined;
            } else if (isFocused) { 
            backgroundColor = '#f1f1f1';
            color = data.color;
            } else {
            backgroundColor = undefined;
            color = data.color;
            }
        
            let activeBackgroundColor;
            if (!isDisabled) {
            if (isSelected) {
                activeBackgroundColor = data.color;
            } else { 
                activeBackgroundColor = '#fff';
            }
            }
        
            return {
            ...styles,
            padding: '5px 8px',
            alignItems: 'center',
            color: 'var(--text-color)', 
            display: 'flex', 
            ':before': { 
                backgroundColor: isSelected ? data.color : color, // This line is modified
                borderRadius: 10,
                content: '" "',
                display: 'block',
                marginRight: 8,
                height: 10,
                width: 10,
            },
            backgroundColor: backgroundColor, 
            cursor: cursor,
            ':active': {
                ...styles[':active'],
                backgroundColor: backgroundColor,
            },
            };
        },
        input: (styles) => ({ 
            ...styles, 
            ...dot(), 
        }),

        placeholder: (styles) => ({ ...styles, ...dot('#ccc') }), 
        singleValue: (styles, { data }) => ({ ...styles, ...dot(data.color) }),

    };
  
    const days = [t('Mon'), t('Tue'), t('Wed'), t('Thu'),  t('Fri'),  t('Sat'),  t('Sun')]
   // const months = ['იან', 'თებ', 'მარ', 'აპრ', 'მაი', 'ივნ', 'ივლ', 'აგვ', 'სექ', 'ოქტ', 'ნოე', 'დეკ']
    const months = [t('Jan'), t('Feb'), t('Mar'), t('Apr'), t('May'), t('Jun'), t('Jul'), t('Aug'), t('Sep'), t('Oct'), t('Nov'), t('Dec')];

    const locale = {
        localize: {
            day: n => days[n],
            month: n => months[n]
        },
        formatLong: {
            date: () => 'MM/dd/yyyy',
            dateTime: () => 'MM/dd/yyyy HH:mm:ss', 
            time: () => 'HH:mm'  
        }
    };
   



  const formatDate = (dateString) => {

 

    if (!dateString) {  
      return t("WithoutDeadline");
    } 

    const atDate = new Date(dateString);
    if (isNaN(atDate.getTime())) {
      return t("WithoutDeadline");
    } 
    if (dateString === "0001-01-01T00:00:00Z") {
      return t("WithoutDeadline");
  }

  
    atDate.setHours(atDate.getHours() - 4);
  
 
    const months = [t('Jan'), t('Feb'), t('Mar'), t('Apr'), t('May'), t('Jun'), t('Jul'), t('Aug'), t('Sep'), t('Oct'), t('Nov'), t('Dec')];

    const day = atDate.getDate();
    const month = months[atDate.getMonth()]; 
    const year = atDate.getFullYear();
    const hours = atDate.getHours().toString().padStart(2, '0');
    const minutes = atDate.getMinutes().toString().padStart(2, '0');
     
    return `${day} ${month} ${year} `;
  };


    return (
        <>
            <style>
                {`
                    .ql-editor {
                        min-height: 200px;  
                    }
                `}
            </style>

            {modalType === 'add' && 
                <span onClick={() => openItem()} className={cl.AddBtn}>
                    <span className={cl.icon} > <Plus /></span>
                    {t('Add')}  
                </span>
            }

            {modalType === 'update' && 
                <span className={ cl.editBtn } onClick={() => openItem()} >
                    <Eye/> {t('View')} 
                </span>
            }       
                       

 
            <Modal size="medium" isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>

                <div className={cl.modalHead} >
                    <h3>
                        <span className={cl.iconHead} > <CheckIcon /></span> 
 
                            <input
                                type="text" 
                                disabled={!app.hasPermission("TASK_UPDATE")}  
                                value={newTask.title}
                                className={validates && validates.title ? cl.inputTitle+' '+ cl.errorInput : cl.inputTitle }
                                onChange={(e) => { 
                                    setNewTask(prevState => ({
                                        ...prevState, 
                                        title: e.target.value
                                    }));
                                }}
 
                            />   
                      
                    </h3>
                </div>


                <div className={cl.container}>
                    <div className={cl.row}>

                        <div className={cl.col}>


                            <div className={`${cl.groupInput} ${validates.auth_id ? cl.errorInput : ''}`}>
                                <label>{t('TaskIssuer')}</label> 
                                <Select
                                    styles={validates && validates.auth_id ? { ...selectStyle, ...stylesError } : selectStyle}
                                    options={salers}  
                                    value={salers.find(option => option.value === newTask.auth_id) || null}
                                    onChange={(selectedOption) => {

                                        setNewTask(prevState => ({
                                            ...prevState,
                                            auth_id: selectedOption ? selectedOption.value : null,
                                        }));
 

                                        userService.getUserById(selectedOption.value).then((user) => {
                                            setCreator(user);
                                        }).catch((error) => {
                                            console.error("მომხმარებელი ვერ მოიძებნა:", error);
                                        });


                                    }}
                                    isClearable={true}
                                    placeholder=""
                                    isDisabled={!app.hasPermission("TASK_UPDATE")}
                                /> 
                                    
                          
                  
                            </div>


                            
                        </div>

                        <div className={cl.col}>


                            <div className={`${cl.groupInput} ${validates.user_id ? cl.errorInput : ''}`}>
                                <label>{t('TaskRecipient')}</label> 
                                <Select
                                    styles={validates && validates.user_id ? { ...selectStyle, ...stylesError } : selectStyle}
                                    options={salers}  
                                    value={salers.find(option => option.value === newTask.user_id) || null}
                                    onChange={(selectedOption) => {
                                        
                                        setNewTask(prevState => ({
                                            ...prevState,
                                            user_id: selectedOption ? selectedOption.value : null,
                                        }));
     
                                        userService.getUserById(selectedOption.value).then((user) => {
                                            setPerformer(user);
                                        }).catch((error) => {
                                            console.error("მომხმარებელი ვერ მოიძებნა:", error);
                                        });
     

                                    }}
                                    isClearable={true}
                                    placeholder=""
                                    isDisabled={!app.hasPermission("TASK_UPDATE")}
                                /> 
                                    
                          
                  
                            </div>


                            
                        </div>
  
                    </div>
                </div>
 

                <div className={cl.row}>


                <div className={cl.col}>
                            <div className={`${cl.groupInput} ${validates.priority ? cl.errorInput : ''}`}>
                                <label>{t('Priority')}</label> 
                                <Select
                                    styles={validates.priority ? { ...selectStyle, ...stylesError, ...colourStyles } : { ...selectStyle, ...colourStyles }}
                                    options={priority_options}
                                    value={priority_options.find(option => option.value === newTask.priority) || null}
                                    onChange={(selectedOption) => { 
                                        setNewTask(prevState => {
                                            const updatedTask = {
                                                ...prevState,
                                                priority: selectedOption ? selectedOption.value : null,
                                            }; 
                                            return updatedTask;
                                        });
                                    }}
                                    isDisabled={!app.hasPermission("TASK_UPDATE")}
                                    placeholder=""
                                />
                                    
                            </div> 
                        </div>

                    

                    <div className={cl.col}> 
                        <div className={`${cl.groupInput} ${validates.deadline_at ? cl.errorInput : ''} withtime`}>

                            <label>{t('Deadline')}</label>

                            <DatePicker 
                                locale={locale}
                                selected={newTask.deadline_at} 
                                dateFormat={'d MMM yyyy'} 
                                timeFormat="HH:mm"  
                                timeIntervals={15}     
                            
                                minDate={new Date()}
                                minTime={newTask.deadline_at && newTask.deadline_at.toDateString() === new Date().toDateString() ? new Date() : new Date(0, 0, 0, 0, 0)} 
                                maxTime={new Date(0, 0, 0, 23, 45)}
        
                                onKeyDown={(e) => {
                                    e.preventDefault();
                                }}

                                onChange={(date) => { 
                                    setNewTask(prevState => ({
                                        ...prevState, 
                                        deadline_at: date
                                    }));
                                }}  
                                popperClassName={cl.dataContainer}
                                wrapperClassName={cl.dataContainer}
                                dataContainer={cl.dataContainer }
                                disabled={!app.hasPermission("TASK_UPDATE")} 
                                isClearable={app.hasPermission("TASK_UPDATE")}  
                                className={validates && validates.deadline_at ? cl.input+' '+ cl.errorInput : cl.input }
                            />
  
                        </div> 
                    </div> 


                    <div className={cl.col}> 
 
                            <div className={ cl.formCheck } style={{ marginTop: '6px' }}> 
                                <input
                                    type="checkbox"
                                    checked={newTask.status === 1}  
                                    id="statusId" 
                                    disabled={!app.hasPermission("TASK_UPDATE")}  
                                    onChange={(e) => {
                                        setNewTask((prevState) => ({
                                            ...prevState,
                                            status: e.target.checked ? 1 : 0
                                        }));
                                    }}
                                />
                                <label htmlFor="statusId" >{t('Done')}</label>
                            </div> 

                    </div>
 
                </div>


                <div className={cl.row}>
                    <div className={cl.col}>                     

                    {(app.hasPermission("TASK_UPDATE") && modalType === 'update') || (app.hasPermission("TASK_ADD") && modalType === 'add') ? (
                           
                           <ReactQuill
                           value={newTask.content}
                           onChange={(v) => { 
                               setNewTask(prevState => ({
                                   ...prevState, 
                                   content: v
                               }));
                           }}

                               modules={{
                               toolbar: [
                                   [{ header: '1' }, { header: '2' }],
                                   [{ list: 'ordered' }, { list: 'bullet' }],
                                   ['bold', 'italic', 'underline'],
                                   [{ color: [] }, { background: [] }],
                                   ['link', 'image'],
                               ],
                               }}
                               theme="snow"
                               formats={[
                               'header',
                               'font',
                               'list',
                               'bullet',
                               'bold',
                               'italic',
                               'underline',
                               'color',
                               'background',
                               'link',
                               'image',
                               ]}

                           />

                    ) : (
                        <div
                            className={cl.contentItem} 
                            dangerouslySetInnerHTML={{ __html: newTask.content }} 
                        ></div>
                    )}
                     

                    </div>
                </div>
 
                    {modalType === 'update' && 
                        <div style={{ display: 'flex', gap: '6px 6px', marginTop: '10px', flexWrap: 'wrap', justifyContent: 'flex-end' }}> 
                            <span className={ cl.badge }>  <span className={cl.icon} ><CalendarIcon/></span> {formatDate(newTask.created_at)}   </span> 
                            <span className={ cl.badge }>  <span className={cl.icon} ><User/></span> {author} </span> 
                        </div>
                    }
  
                    {app.hasPermission("TASK_UPDATE") && 
                        <span onClick={saveHandle} className={cl.btnPrimary}>{t('Save')}</span>
                    } 
                  

            </Modal>
        </>
    );
};

export default ItemTaskModal;